import { useQuery } from 'react-query';

import { useRequest } from '@frontend/api';
import type { QueryFunction } from '@frontend/api';

export type PurchasedComponentMatchesParams = {
  componentIds: string[];
  partNumbers: string[];
};

export type PurchasedComponentMatchesResponseData = {
  uuid: string;
  purchasedComponentId: number;
  partNumber: string;
  description: string | null;
};

export type PurchasedComponentMatchesQueryKey = readonly [
  'suppliers',
  'purchasedComponentMatches',
  PurchasedComponentMatchesParams,
];

const purchasedComponentMatchesQueryKey = (
  params: PurchasedComponentMatchesParams,
): PurchasedComponentMatchesQueryKey => [
  'suppliers',
  'purchasedComponentMatches',
  params,
];

export const usePurchasedComponentMatches: QueryFunction<
  PurchasedComponentMatchesResponseData[],
  [PurchasedComponentMatchesParams],
  PurchasedComponentMatchesQueryKey
> = (params, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useQuery({
    ...queryOptions,
    queryKey: purchasedComponentMatchesQueryKey(params),
    queryFn: ({ signal }) => {
      return request(`/suppliers/purchased_component_matches`, {
        init: {
          signal,
          method: 'POST',
          body: params,
        },
      });
    },
  });
};
